import { 
    FaHashtag,  
    FaUser,  
    Header, 
    FaTasks,
    OptionHelper,
    RecordMap
} from "@/Shared";

import { AgentTargetViewModel } from ".";
import { UserModel } from "@/Domains/User";


export class AgentTargetHeader {

    private constructor() { }

    get id() {
        return {
            key: 'id',
            icon: <FaHashtag />,
            label: 'ID',
            type: 'number',
            isSortable: true
        }
    }

    getAgent(userMap : RecordMap<UserModel>) {
        return {
            key: 'agent',
            icon: <FaUser />,
            label: 'Agent',
            type: 'string',
            isSortable: true,
            filter: {
                label: 'Agent',
                case: 'insensitive',
                options: OptionHelper.userOptions(userMap.toArray()),
            }
        }
    }

    getYear() {
        return {
            key: 'year',
            icon: <FaHashtag />,
            label: 'Année',
            type: 'number',
            isSortable: true
        }
    }

    getRentalTarget() {
        return {
            key: 'rentalTarget',
            icon: <FaTasks />,
            label: 'Locations',
            type: 'number',
            isSortable: true
        }
    }

    getSalesTarget() {
        return {
            key: 'salesTarget',
            icon: <FaTasks />,
            label: 'Ventes',
            type: 'number',
            isSortable: true
        }
    }

    getOtherProductsTarget() {
        return {
            key: 'otherProductsTarget',
            icon: <FaTasks />,
            label: 'Autres produits',
            type: 'number',
            isSortable: true
        }
    }

    getCaTarget() {
        return {
            key: 'caTarget',
            icon: <FaTasks />,
            label: 'CA',
            type: 'number',
            isSortable: true
        }
    }

    getMandatesTarget() {
        return {
            key: 'mandatesTarget',
            icon: <FaTasks />,
            label: 'Mandats',
            type: 'number',
            isSortable: true
        }
    }


    static build(userMap : RecordMap<UserModel>): Record<keyof AgentTargetViewModel, Header<AgentTargetViewModel>> {
        const header = new AgentTargetHeader();

        return {
           id: header.id,
           agent: header.getAgent(userMap),
           year: header.getYear(),
           rentalTarget: header.getRentalTarget(),
           salesTarget: header.getSalesTarget(),
           mandatesTarget: header.getMandatesTarget(),
           otherProductsTarget: header.getOtherProductsTarget(),
           caTarget: header.getCaTarget(),
       } as Record<keyof AgentTargetViewModel, Header<AgentTargetViewModel>>;
    }
}
